import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FullNamePipe } from '@shared/pipes/fullname.pipe';

@Component({
  imports: [FullNamePipe, MatIcon],
  selector: 'ui-assignee',
  styleUrl: './assignee.component.scss',
  template: `
    <div class="font-semibold flex gap-2">
      Assigned to:
      <div class="assignee-person flex gap-1">
        <mat-icon class="assignee-icon">person</mat-icon>
        {{ assignee() | fullName: 'lastFirst' }}
      </div>
    </div>
  `,
})
export class AssigneeComponent {
  assignee = input<{
    first_name: string;
    last_name: string;
    email: string;
  }>();
}
